module.exports = __webpack_public_path__ + "static/img/start.d9fd9fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/tideng/springFestival/cook/start.png
// module id = YgVf
// module chunks = 4